// src/utils/accessGate.js
// Client side of the dashboard access gate (server: GET /auth/onboarding-gate →
// onboardingHelpers.getAccessGate). Rules (Founder, 2026-10-04): email + phone verified,
// profile ≥ 70% and a first gig/request before the dashboard. Identity verification is optional.
import api from '../services/api';

const CACHE_MS = 60 * 1000;
let cached = null; // { value, at }

/** Where to send a user for a given gate step. null → allowed through. */
export function routeForGateStep(step) {
  switch (step) {
    case 'verify-contact': return '/verify-parallel';
    case 'google':         return '/onboarding?resume=true';
    case 'profile1':       return '/onboarding?resume=true&step=profile1';
    case 'firstgig':       return '/onboarding?resume=true&step=firstgig';
    default:               return null;
  }
}

/** Fetch the gate (cached briefly so moving between dashboard pages doesn't refetch). */
export async function fetchAccessGate({ force = false } = {}) {
  if (!force && cached && Date.now() - cached.at < CACHE_MS) return cached.value;
  const res = await api.get('/auth/onboarding-gate');
  const value = res.data || {};
  cached = { value, at: Date.now() };
  return value;
}

export function clearAccessGateCache() {
  cached = null;
}
